// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";
import VideoShareStore from "app/stores/VideoShareStore";

import "./TimelineCardShare.scss";

type Props = {
    item: TimelineItem
};

@observer
export default class TimelineCardShare extends React.Component<Props> {
    render() {
        const { item } = this.props;

        return (
            <button
                className="TimelineCardShare"
                onClick={() => VideoShareStore.shareAt(item.start_time)}
                title="Resume video from here"
            >
                <i className="fa fa-share TimelineCardShare__icon" />
                <span className="TimelineCardShare__text">Share</span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardShare/TimelineCardShare.js